export { default as getPageRoot } from './src/api.jsx';